<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="contract" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="contract-head">
            <h1 class="hdg03">利用者アカウントの一括登録・更新</h1>
          </div>
          <form class="contract-container">
            <div class="contract-content">
              <template v-if="file.step === 'init' || file.step === 'selected'">
                <div>
                  <p class="hdg04" style="font-size:2.4rem;">設定ファイルダウンロード</p>
                  <span @click="file.csvDownload" class="txt-blue" role="button"><FontawesomeIcon class="icn-download" icon="arrow-to-bottom" />一括登録・更新用設定ファイルダウンロード（CSV)</span>
                </div>
                
                <div class="contract-content-upload mt100">
                  <p class="hdg04" style="font-size:2.4rem;">一括登録・更新</p>
                  <p class="txt">新規登録・停止・再開したアカウントに変更内容をメールで通知します。<br>連絡先の管理者アカウント名・メールアドレスに変更が必要な場合は編集してください。</p>
                  <table>
                    <tr>
                      <th>管理者アカウント名</th>
                      <td>
                        <div class="formparts text">
                          <input type="text" v-model="input.name">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>管理者メールアドレス</th>
                      <td>
                        <div class="formparts text">
                          <input type="text" v-model="input.email">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>登録・更新用CSVファイル</th>
                      <td>
                        <div class="formparts function file">
                          <label for="file_upload" role="button">
                            <input type="file" id="file_upload" accept=".csv" @change="file.onChange">
                            <span :class="[file.data ? 'selected-txt' : '']" class="fake-txt">{{file.name}}</span>
                          </label>
                        </div>
                      </td>
                    </tr>
                  </table>


                  <div class="contract-submit">
                    <div class="button contract-submit-button" :class="{'is-inactive': !file.data}">
                      <button class="btn" type="submit" name="button" @click.prevent="file.csvUpload">一括更新</button>
                    </div>
                  </div>
                </div>
              </template>
              <div class="contract-content-loading" v-else-if="file.step === 'loading'">
                <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt100 icn fa-spin" />
              </div>
              <template v-else-if="file.step === 'complete'">
                <div class="contract-content-complete">
                  <p class="hdg04" style="font-size:2.4rem;">登録完了</p>
                  <router-link to="/pc/contract-account" class="box02-hdg-aside-menu">利用者アカウント管理へ​</router-link>
                  <router-link to="/pc/contract-assign-license-table" target="_blank" class="box02-hdg-aside-menu">全サービスのライセンスを表示<FontawesomeIcon icon="external-link-alt" class="icn-blank" /></router-link>
                </div>
              </template>
              <template v-else>
                <div class="contract-content-error">
                  <p class="hdg04" style="font-size:2.4rem;">エラー</p>
                  <p class="txt">アップロードしたファイルに不整合があります。<br>修正して、再度お試しください。</p>
                  <span @click="file.backInit" class="txt-blue" role="button">戻る</span>
                </div>
                <div class="message-area mt20">
                  <p v-for="(errorMessage, index) in file.errorMessages" :key="index" class="error-message mb0">{{errorMessage}}</p>
                </div>
              </template>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'

import * as apiProfile from '@/api/profile'
import * as apiGuide from '@/api/contract'
import * as _ from 'lodash'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu
  },
  setup (props, context) {
    const store = context.root.$store
    const { profile } = store.state

    const input = reactive({
      name: '',
      email: ''
    })

    input.name = profile.name
    input.email = profile.email
    
    const file = reactive({
      step: 'init', // init, selected, loading, complete, error
      data: null,
      name: 'CSVファイルを選択してください',
      errorMessages: [],
      onChange: (e) => {
        const files = e.target.files || e.dataTransfer.files
        file.name = files[0].name || 'CSVファイルを選択してください'

        file.data = files
        file.step = 'selected'
      },
      csvUpload: async() => {
        // 同一画面でとどまる可能性が高いので、プロフィールAPIを呼び出し必要な場合はトークン更新させる
        await apiProfile.fetch()

        file.step = 'loading'

        const params = {
          id: profile.id,
          name: input.name,
          email: input.email
        }
        apiGuide
          .updateAccountCSV(file.data[0], params)
          .then(res => {
            const { data } = res
            if (data.status === 0) {
              file.step = 'complete'
            } else {
              file.step = 'error'
              data.error_message && file.errorMessages.push(data.error_message)

              _.forEach(data.validation_message, messages => {
                if (_.isArray(messages)) {
                  file.errorMessages.push(...messages)
                } else {
                  file.errorMessages.push(messages)
                }
              })
            }
          })
          .catch(res => {
            file.step = 'error'
          })
      },
      csvDownload: async() => {

        apiGuide
          .getAccountCSV()
          .then(async (res) => {
            if (res.data.type === 'application/octet-stream') {
              const contentDisposition = res.headers['content-disposition']
              const fileName = file.getFilename(contentDisposition)
              const blob = new Blob([res.data], { 'type': 'text/csv' })
              if (window.navigator && window.navigator.msSaveBlob) {
                // IE
                window.navigator.msSaveBlob(blob, fileName)
              } else {
                // Other
                const downLoadLink = document.createElement('a')
                downLoadLink.download = fileName
                downLoadLink.href = URL.createObjectURL(blob)
                downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href].join(':')
                downLoadLink.click()
              }
            } else {
              const blob = new Blob([res.data], { 'type': 'application/json' })
              const reader = new FileReader()
              reader.addEventListener('loadend', () => {
                const json = JSON.parse(reader.result)
                if (json && json.status && json.status !== 0) {
                  store.dispatch('common/showNotice', { title: 'エラー', text: json.error_message })
                }
              })
              reader.readAsText(blob)
            }
          })
      },
      getFilename: (contentDisposition) => {
        const reg = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = reg.exec(contentDisposition)
        if (matches != null && matches[1]) {
          const fileName = matches[1].replace(/['"]/g, '')
          return decodeURI(fileName)
        } else {
          return 'export.csv'
        }
      },
      backInit: () => {
        file.name = 'CSVファイルを選択してください'
        file.data = null
        file.step = 'init'
        file.errorMessages = []
      }
    })

    return {
      file,
      input
    }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.contract {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-submit {
    width: 230px;
    // margin: 40px auto;
    // margin-top: 64px;
  }
  &-content {
    max-width: 920px;
    padding: 0 40px;
    margin: 0 auto;
    .icn-download {
      margin-right: 5px;
    }
    .icn-blank {
      margin-left: 5px;
    }
    .txt {
      line-height: 1.625;
    }
    .hdg03 {
      margin: 62px 0 30px;
      padding-bottom: 14px;
      border-bottom: 1px solid $color-line;
    }
    .link {
      color: $color-link;
    }
    .message-area {
      width: 640px;
      margin: auto;
      height: 100vh;
      overflow: auto;
    }
    &-upload {
        table {
          border-collapse: collapse;
          margin: 40px 0;
          th,td {
            font-size: 1.6rem;
            vertical-align: baseline;
            padding-bottom: 28px;
          }
          th {
            color: #3E3E3E;
            padding: 8px 16px 8px 0;
            white-space: nowrap;
            text-align: left;
            width: 200px;
          }
          td {
            color: #555555;
            width: 400px;
          }
        }
      .formparts.file {
        width: 520px;
        position: relative;
        height: 28px;
        .fake-txt {
          width: 100%;
          color: #ddd;
        }
        .selected-txt {
          color: #555 !important;
        }
        label {
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
    &-loading {
      text-align: center;
    }
    &-complete {
      text-align: center;
    }
    &-error {
      text-align: center;
    }
    &-info {
      display: table;
      table-layout: fixed;
      width: 100%;
      margin: 28px 0 20px;
      &-notice {
        display: table-cell;
        vertical-align: bottom;
        font-size: 1.4rem;
        line-height: 1.57;
        color: $color-sup;
      }
      &-nothing {
        color: #999999;
        text-align: center;
        padding: 40px;
      }
      &-num {
        display: table-cell;
        vertical-align: bottom;
        text-align: right;
        padding: 0 18px;
        line-height: 1.57;
        &-hdg {
          display: flex;
          color: $color-sup;
          align-items: center;
          font-size: 1.4rem;
          float: right;
          p {
            margin-left: 12px;
          }
          &-txt {
            font-size: 2rem;
            color: $color-hdg;
            font-weight: bold;
            line-height: 1.1;
            margin-top: -3px;
            .max {
              color: $color-highlight;
            }
          }
        }
      }
      
    }
    &-table{
      overflow-y: auto;
      thead{
        th{
          background: $color-bg-paper;
          border-bottom: 0;
        }
      }
      tbody{
        td{
          span.txt-blue + span.txt-blue{
            margin-left: 35px;
            padding-left: 20px;
            border-left: 1px solid rgba(153, 153, 153, 0.2);
          }
        }
      }
    }
  }
}
.fixed-header {
  tbody {
    display: block;
    max-height: 330px;
    overflow-y: scroll;
  }
  thead,
  tbody tr {
    display: table;
    width: 100%;
  }
}
</style>
